/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import {ConfigProvider, ThemeConfig} from 'antd'
import {LOCALE} from 'helpers/config'
import {localeObject} from 'utils/localeUtils'
import DatePicker from 'components/DatePicker'

const { RangePicker: AntdRangePicker } = DatePicker

/** Match brand teal used by UiDateRangeCalendar (`cta-light`). */
export const ANTD_PICKER_THEME: ThemeConfig = {
    token: {
        colorPrimary: '#0c97a3',
        borderRadius: 8,
        fontFamily: 'inherit',
    },
}

type AntdPickerConfigProps = {
    children: React.ReactNode
}

export const AntdPickerConfigProvider = ({ children }: AntdPickerConfigProps) => (
    <ConfigProvider locale={localeObject(LOCALE)} theme={ANTD_PICKER_THEME}>
        {children}
    </ConfigProvider>
)

export const AntdDatePicker = (props: any) => {
    return (
        <AntdPickerConfigProvider>
            <DatePicker
                needConfirm={false}
                {...props}
                className={"text-xs placeholder:text-xxs"}
            />
        </AntdPickerConfigProvider>
    )
}

export const AntdRangePickerComponent = (props: any) => {
    return (
        <AntdPickerConfigProvider>
            <AntdRangePicker needConfirm={false} {...props} />
        </AntdPickerConfigProvider>
    )
}
